import {useEffect, useRef} from 'react';
import {useDispatch} from 'react-redux';
import {hidePageMessage, showPageMessage, PageMessage} from '../coreSlice';

let idCount = 0;

export const usePageMessage = (pageMessage: PageMessage, dependencies: unknown[] = [], when = true) => {
  const dispatch = useDispatch();
  const pageMessageRef = useRef(pageMessage);
  pageMessageRef.current = pageMessage;

  useEffect(() => {
    if (when) {
      const id = pageMessageRef.current.id ?? `${++idCount}`;
      dispatch(showPageMessage({...pageMessageRef.current, id}));
      return () => {
        dispatch(hidePageMessage({id}));
      };
    }
  }, [dispatch, when, ...dependencies]);
};
